import { render, staticRenderFns } from "./SampleResultNoise.vue?vue&type=template&id=12900b87&scoped=true"
import script from "./SampleResultNoise.vue?vue&type=script&lang=js"
export * from "./SampleResultNoise.vue?vue&type=script&lang=js"
import style0 from "./SampleResultNoise.vue?vue&type=style&index=0&id=12900b87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12900b87",
  null
  
)

export default component.exports